import { useTranslation } from 'react-i18next';
import { ROUTE, STORAGE_BASE_URL } from '../Settings';

const AppHeader = (): any => {
    const { t } = useTranslation();
    const imageUrl = `${STORAGE_BASE_URL}${ROUTE}`;

    return (
        <div className={'locker-plugin-header d-flex flex-row'}>
            <img src={`${imageUrl}/Logo_Sameday.png`}></img>
            <div className={'d-flex mx-auto my-auto'}>
                <h5>{t("welcomePageTitle")}</h5>
                <div className={'position-relative'}>
                    <img className={'position-relative locker-plugin-sameday-easybox-logo'} src={`${imageUrl}/Logo_Easybox.png`}></img>
                </div>
            </div>
        </div>
    )
}

export default AppHeader;